import { render, staticRenderFns } from "./DoubleCtaSectionModule.vue?vue&type=template&id=4279e41b&"
import script from "./DoubleCtaSectionModule.vue?vue&type=script&lang=js&"
export * from "./DoubleCtaSectionModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports